/* ONE predicate -- IS THIS EMPLOYEE ALREADY TERMINATED IN PAYROLL? (W-072, Brian 2026-10-02)

   Asked by two surfaces, so it lives once: Payroll's termination dialog (an employee already terminated is
   not offered again) and Scenarios (a scenario's termination of such an employee is IGNORED -- the real
   termination wins -- and flagged so it can be removed).

   The termination is the model's own: ModelProvider gives each employee `termDate` -- inferred from the
   stored salary series (the last month with salary, when that falls before the end of the window), else
   end_date -- the same field the engine books the termination and its severance on. A termination in or
   after the LAST forecast month is not one inside the forecast, so such an employee still counts as active
   (the dialog's long-standing rule, kept exactly). Returns null, or { month: "YYYY-MM", endDate }. */
import { formatMonthLabel } from "../engines/dateUtils";

export function payrollTermination(emp, lastForecast) {
  const t = emp && emp.termDate;
  if (!t) return null;
  const month = String(t).slice(0, 7);
  if (lastForecast && month >= lastForecast) return null;
  const endDate = emp.end_date ? String(emp.end_date).slice(0, 10) : null;
  return { month, endDate };
}

/* "on Jun 28, 2023" when the stored end date is known, else "in Jun 2023" (the month the model terminates on). */
export function payrollTerminationWhen(pt) {
  if (!pt) return "";
  if (pt.endDate && /^\d{4}-\d{2}-\d{2}$/.test(pt.endDate)) {
    const [y, , d] = pt.endDate.split("-").map(Number);
    return "on " + formatMonthLabel(pt.endDate.slice(0, 7), "short") + " " + d + ", " + y;
  }
  return "in " + formatMonthLabel(pt.month, "shortFull");
}

/* The flag a scenario shows on a termination it ignores. */
export function scenarioTerminationIgnoredNote(pt) {
  return "Already terminated in Payroll " + payrollTerminationWhen(pt) + " \u2014 this scenario's termination is ignored.";
}
